<template>
  <div>
    <div class="title-h4">수집 설정</div>
    <el-form class="mr-b25" :model="logInfo" label-position="top" ref="fileInfoForm" :rules="formRules">
      <el-row>
        <el-form-item label="수집 서버">
          <el-select v-model="logCollectorId">
            <el-option label="미배정" :value="null" />
            <el-option v-for="col in logCollectors" :key="col.logCollectorId" :label="col.logCollectorName" :value="col.logCollectorId" />
          </el-select>
        </el-form-item>
      </el-row>
      <el-row type="flex" justify="space-between">
        <el-col :span="6">
          <el-form-item label="파일 저장 여부">
            <el-switch v-model="logInfo.logSaveFileFlag" active-value="Y" inactive-valur="N" />
          </el-form-item>
        </el-col>
        <el-col :span="6" class="mr-r10">
          <el-form-item label="파일 압축">
            <el-switch v-model="logInfo.compressFlag" active-value="Y" inactive-valur="N" :disabled="!checkFlagsTrue(logInfo.logSaveFileFlag)" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="파일 보관 기한(일)" prop="retentionAge">
            <el-input-number v-model="logInfo.retentionAge" :disabled="!checkFlagsTrue(logInfo.logSaveFileFlag)" :min="1" controls-position="right" />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row type="flex" justify="space-between">
        <el-col :span="12" class="mr-r10">
          <el-form-item label="파일 암호화">
            <el-switch v-model="logInfo.encryptFlag" active-value="Y" inactive-valur="N" :disabled="!checkFlagsTrue(logInfo.logSaveFileFlag)" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="비밀번호" prop="changedEncryptPw">
            <el-button v-if="logInfo.currentEncryptPwFlag === 'Y'" type="primary" @click="onToggleChangePwFlag" :disabled="!checkFlagsTrue(logInfo.logSaveFileFlag) || !checkFlagsTrue(logInfo.encryptFlag)">비밀번호 변경하기</el-button>
            <el-input v-else type="password" v-model="logInfo.changedEncryptPw" :disabled="!checkFlagsTrue(logInfo.logSaveFileFlag) || !checkFlagsTrue(logInfo.encryptFlag)" />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <w-file-pw-change-popup ref="pwChangePopup" :log-info="logInfo"></w-file-pw-change-popup>
  </div>
</template>

<script>
import msgUtil from '@/utils/message';
import { isNil } from 'lodash';
import IntegratedSyslogSettingAPI from '@/api/settings/log/integrated-syslog-settings';
import { isTrue } from '@/utils/boolean';

import WFilePwChangePopup from '../popup/FilePwChangePopup';

export default {
  name: 'WFileSettingPopupContent',
  components: {
    WFilePwChangePopup,
  },
  props: {
    logInfo: Object,
    disabled: Boolean,
  },
  data() {
    const retentionAgeValidator = (rule, value, callback) => {
      if (this.checkFlagsTrue(this.logInfo.logSaveFileFlag) && (isNil(value) || value === 0)) {
        callback(new Error('파일 보관 기한을 입력해주세요.'));
      } else {
        callback();
      }
    };
    const encryptPwRule = (rule, value, callback) => {
      if (this.logInfo.currentEncryptPwFlag === 'N' && this.logInfo.encryptFlag === 'Y' && !value) {
        callback(new Error('파일 암호화 활성화 시 비밀번호를 입력해주세요.'));
      } else if (value && value.length > 255) {
        callback(new Error('255자 이내로 입력해주세요.'));
      } else {
        callback();
      }
    };

    const formRules = {
      retentionAge: [
        { required: true, validator: retentionAgeValidator, trigger: 'blur' },
      ],
      changedEncryptPw: [
        { validator: encryptPwRule, trigger: 'blur' },
      ],
    };
    return {
      logCollectorId: null,
      logCollectors: [],
      logInfoClone: {},
      changedEncryptPw: null,
      formRules,
    };
  },
  watch: {
    logInfo(value) {
      if (!isNil(value.logCollectorId)) {
        this.logCollectorId = value.logCollectorId;
      }
    },
  },
  created() {
    this.loadCollectors();
  },
  methods: {
    /**
     * [콤보박스] 수집서버 목록을 조회해온다.
     * @author Minyeong
     * @return {[type]} [description]
     */
    loadCollectors() {
      IntegratedSyslogSettingAPI.getLogCollectors().then((response) => {
        if (response.data.success) {
          this.logCollectors = response.data.data;
        }
      }).catch((e) => {
        this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '수집서버 목록', false));
        throw new Error(e);
      });
    },
    /**
     * 플래그가 true인지 확인한다.
     * @author Minyeong
     * @param  {[type]} flag [description]
     * @return {[type]}      [description]
     */
    checkFlagsTrue(flag) {
      if (isNil(flag) || !isTrue(flag)) {
        return false;
      }
      return true;
    },
    /**
     * Validation을 확인한다.
     * @author Minyeong
     * @return {[type]} [description]
     */
    checkValidation() {
      this.$refs.fileInfoForm.validate().then((success) => {
        if (success) {
          this.logInfo.logCollectorId = this.logCollectorId;
          this.$emit('go-to-next');
        }
      }).catch(() => {});
    },
    onToggleChangePwFlag() {
      this.$refs.pwChangePopup.open();
    },
    initValidation() {
      const clear = ['retentionAge', 'encryptPwRule'];
      this.$refs.fileInfoForm.clearValidate(clear);
    },
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/settings/log-analysis/Collect/Syslog/components/FileSettingPopupContent.vue